import React from 'react';
import { Layout } from 'antd';

import PageHeader from './page-header';
import { useStore } from './store';

import './cyber-security-training.less';
import './cyber-security-training.mobile.less';

interface IPageLayoutProps {
  pageName: string;
  noHeader?: boolean;
  pageClass?: string;
}

const PageLayout: React.FunctionComponent<IPageLayoutProps> = (props) => {
  const { page, language } = useStore();
  if (!page) {
    return <div>Loading...</div>;
  }
  return (
    <div
      className={`cyber-security-training-page ${props.pageName} ${language} ${
        props.pageClass === 'cybersecurity2024'
          ? 'general2024'
          : props.pageClass
      }`}
    >
      <Layout>
        {props.noHeader !== undefined && props.noHeader ? null : <PageHeader />}
        <Layout.Content>{props.children}</Layout.Content>
      </Layout>
    </div>
  );
};

export default PageLayout;
